module.exports = __webpack_public_path__ + "img/traffic_jam.e8ea1af4.svg";